const JWT_LIKE = /eyJ[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}/g;
const BEARER = /Bearer\s+[A-Za-z0-9._\-+=/]+/gi;
const ASSIGNED_SECRET =
  /\b(accessToken|refreshToken|password|passwd|secret|authorization|api[_-]?key|ninet6_player_session)\b\s*[:=]\s*("[^"]*"|'[^']*'|[^\s,;]+)/gi;

export function redactDepositErrorText(text) {
  try {
    let s = String(text == null ? '' : text);
    s = s.replace(JWT_LIKE, '[redacted-token]');
    s = s.replace(BEARER, 'Bearer [redacted]');
    s = s.replace(ASSIGNED_SECRET, '$1=[redacted]');
    if (s.length > 4000) s = s.slice(0, 4000) + '\n…';
    return s;
  } catch {
    return '';
  }
}

export function applicationFrames(stack) {
  const raw = redactDepositErrorText(stack);
  return raw
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean)
    .filter((l) => !/node_modules|react-dom|react-router|scheduler/i.test(l))
    .slice(0, 12);
}

export function formatDepositRenderError(error, errorInfo) {
  const message = redactDepositErrorText(
    error && error.message ? error.message : String(error || 'Unknown error')
  );
  const componentStack = redactDepositErrorText((errorInfo && errorInfo.componentStack) || '');
  const appFrames = applicationFrames((error && error.stack) || '');
  return { message, componentStack, appFrames };
}
